import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { JkBaseComponent } from 'jk-service';
import { companyList } from '../../environments/util-environment';
import { UtilApiAuthService } from './util-api-auth.service';

@Component({
  selector: 'app-util-api-auth',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './util-api-auth.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UtilApiAuthComponent extends JkBaseComponent {
  override comType = 'util-api-auth';
  readonly auth = inject(UtilApiAuthService);
  apiBaseUrl = this.auth.credentials()?.apiBaseUrl || companyList[0]?.ps1 || '';
  token = '';
  readonly status = signal('');
  readonly checking = signal(false);

  async saveToken(): Promise<void> {
    this.status.set('');
    try {
      this.auth.save(this.apiBaseUrl, this.token || this.auth.credentials()?.token || '');
      this.token = '';
      this.checking.set(true);
      await firstValueFrom(this.http.get(`${this.auth.credentials()!.apiBaseUrl}/health`, { timeout: 10000 }));
      this.auth.unauthorized.set(false);
      this.status.set('驗證成功，請重新整理目前功能以重試請求。');
    } catch {
      this.status.set('儲存或驗證失敗，請檢查 API 網址、token 格式與連線。');
    } finally {
      this.checking.set(false);
    }
  }

  clearToken(): void {
    this.auth.clear();
    this.token = '';
    this.status.set('已清除 token。');
  }
}
